import { useState, useCallback, Fragment } from "react";
import { Button, Modal, Tag } from "antd";
import TypeList from "./TypeList";
import DepartmentTable from "./DepartmentTable";

function MultipleDepartmentSelect({ value = [], onChange, token, role }) {
  const [type, setType] = useState("all");
  const [visible, setVisible] = useState(false);

  // const [selectedRows, setSelectedRows] = useState([]);
  // const [selectedTypes, setSelectedTypes] = useState([]);

  // useEffect(() => {
  //   if (value.length !== 0) {
  //     setSelectedTypes(value.filter((v) => v.type === "t"));
  //     setSelectedRows(value.filter((v) => v.type !== "t"));
  //   }
  // }, [setSelectedTypes, setSelectedRows, value]);
  const clickHandler = useCallback(() => {
    setVisible(true);
  }, [setVisible]);
  const cancelHandler = useCallback(() => {
    setVisible(false);
  }, [setVisible]);
  const deleteHandler = useCallback(
    (id) => {
      onChange(value.filter((r) => r.id !== id));
    },
    [onChange, value]
  );
  const typeChangeHandler = useCallback(
    (id, name, checked) => {
      if (checked) {
        onChange([...value, { id, name, type: "t" }]);
      } else {
        onChange(value.filter((t) => t.id !== id));
      }
    },
    [value, onChange]
  );
  const rowChangeHandler = useCallback(
    (id, name, checked) => {
      if (checked) {
        onChange([...value, { id, name, type: "d" }]);
      } else {
        onChange(value.filter((t) => t.id !== id));
      }
    },
    [value, onChange]
  );

  return (
    <Fragment>
      <Button type="text" onClick={clickHandler}>
        [请选择]
      </Button>
      <div className="tag-container">
        {value.map((r) => (
          <Tag
            key={r.id}
            closable
            onClose={(e) => deleteHandler(r.id)}
            className="b-tag"
          >
            {r.name}
          </Tag>
        ))}
      </div>
      <Modal
        title="选择单位"
        visible={visible}
        width={800}
        bodyStyle={{ padding: 0 }}
        onCancel={cancelHandler}
        destroyOnClose={true}
        footer={[
          <Button key="back" onClick={cancelHandler}>
            关闭
          </Button>,
        ]}
      >
        <div className="modal-depart-container">
          <div className="modal-depart-type">
            <TypeList
              types={value.filter((v) => v.type === "t")}
              type={type}
              setType={setType}
              token={token}
              role={role}
              onChange={typeChangeHandler}
            />
          </div>
          <div className="modal-depart-table">
            <DepartmentTable
              rows={value.filter((v) => v.type !== "t")}
              type={type}
              token={token}
              onChange={rowChangeHandler}
            />
          </div>
        </div>
      </Modal>
    </Fragment>
  );
}

export default MultipleDepartmentSelect;
